
import React, { PropTypes } from 'react';

export default function Modal(props) {

  const onClickOut = (event) => props.onClickOut && props.onClickOut(event);
  const onClickIn = (event) => event.stopPropagation();

  return (
    <div className={`modal-component`}
         data-id='Modal'
         onClick={onClickOut}>
      <div className={`modal-content-wrapper`}
           onClick={onClickIn}>
        <div className={`modal-content`}>
        {
          props.children
        }
        </div>
        <div className='rectangle-behind-modal'/>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./shared/common/components/Modal.js